import cn from 'classnames'
import { BogoQuizActionsCopy } from '@mc/bogo'
import { useBogo } from '@mc/bogo-utils'
import { usePromotion } from '@mc/promo-utils'
import { PromoQuizStickyFooterCopy } from '@mc/promos'
import { QuizMachineContext } from '../../context'
import { BackButton } from './BackButton'
import { NextButton, type NextButtonProps } from './NextButton'

interface ButtonGroupProps extends NextButtonProps {
  isMobile?: boolean
}

export const ButtonGroup = ({
  disabledText,
  disabled,
  onNext,
  isMobile = false,
}: ButtonGroupProps) => {
  const { isPromotionOn } = usePromotion()
  const { isBogoOfferEligible } = useBogo({ isGift: false })

  const isBogoOfferInterstitial = QuizMachineContext.useSelector((snapshot) =>
    snapshot.matches('bogoOfferInterstitial'),
  )

  const promoCopy =
    isPromotionOn || (isBogoOfferEligible && !isBogoOfferInterstitial)

  return (
    <div className='row justify-content-center'>
      <div
        className={cn('col-12 col-md-10 col-lg-7 mc-p-4', {
          'mc-bg-container-dark mc-corners--md': promoCopy,
          'mc-px-9': isMobile,
        })}
      >
        {promoCopy && (
          <div
            className={cn(
              'mc-mb-4 mc-py-3 mc-px-4',
              'mc-text--left mc-bg-container-tint-medium mc-corners--sm',
            )}
          >
            <PromoQuizStickyFooterCopy />
            <BogoQuizActionsCopy />
          </div>
        )}

        <div className='d-flex flex-row align-items-center justify-content-center'>
          <div className='mc-mr-4'>
            <BackButton
              size={isMobile ? 'md' : 'sm'}
              iconSize={isMobile ? 'scale-8' : 'sm'}
            />
          </div>
          <div className='flex-1 d-flex' style={{ gap: '8px' }}>
            <NextButton
              disabled={disabled}
              disabledText={disabledText}
              onNext={onNext}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
